export default {
    pageName: 'อนุมัติคำร้อง',
    search: {
        title: '',
        placeholder: 'สถานะการลา'
    },
    header: {
        full: 'รายละเอียด',
        sub: 'วันที่ลา'
    },
    button: {
        approve: 'อนุมัติ',
        reject: 'ไม่อนุมัติ'
    },
    modalSuccess: {
        title: 'ส่งข้อมูลสำเร็จ',
        body: 'อนุมัติคำร้องสำเร็จ',
        btnOk: 'ยืนยัน'
    },
    modalFail: {
        title: 'ขออภัย ไม่สามารถดำเนินการได้',
        body: '',
        btnOk: 'ปิด'
    }
}
